import { useEffect, useState } from "react";
import { getSupabase } from "@/lib/supabaseClient";

export default function SupabaseTest() {
  const [sessionInfo, setSessionInfo] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const testSupabase = async () => {
      const supabase = getSupabase();
      
      console.log("🧪 [SupabaseTest] Testing Supabase configuration...");
      
      // Test 1: Check current session
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      console.log("🧪 [SupabaseTest] Current session:", { session, error: sessionError });
      
      // Test 2: Check user
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      console.log("🧪 [SupabaseTest] Current user:", { user, error: userError });
      
      // Test 3: Check auth state
      const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
        console.log("🧪 [SupabaseTest] Auth state change:", { event, session });
      });
      
      setSessionInfo({
        session: session ? { id: session.user?.id, email: session.user?.email } : null,
        user: user ? { id: user.id, email: user.email } : null,
        sessionError: sessionError?.message,
        userError: userError?.message
      });
      
      setLoading(false);
      
      // Cleanup subscription
      setTimeout(() => subscription.unsubscribe(), 5000);
    };
    
    testSupabase();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p>Testing Supabase configuration...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Supabase Configuration Test</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Current Session Status</h2>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
            {JSON.stringify(sessionInfo, null, 2)}
          </pre>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">URL Information</h2>
          <div className="space-y-2">
            <p><strong>Current URL:</strong> {window.location.href}</p>
            <p><strong>Origin:</strong> {window.location.origin}</p>
            <p><strong>Search Params:</strong> {window.location.search || "none"}</p>
            <p><strong>Hash:</strong> {window.location.hash || "none"}</p>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Next Steps</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>Go to Supabase Dashboard → Authentication → URL Configuration</li>
            <li>Change Site URL to: <code className="bg-gray-100 px-2 py-1 rounded">http://localhost:8080</code></li>
            <li>Add Redirect URLs: <code className="bg-gray-100 px-2 py-1 rounded">http://localhost:8080/auth/callback</code></li>
            <li>Try OAuth again</li>
          </ol>
        </div>
      </div>
    </div>
  );
}












